export default {
    // error title
    // 재배차 실패
    FAIL_REALLOCATE: 'fail_reallocate',
    // 즉시배차 실패
    FAIL_IMMEDIATE_ALLOCATE: 'fail_immediate_allocate',
    // 배차요청 실패
    FAIL_REQUEST_ALLOCATE: 'fail_request_allocate',
    // 배차요청 거절
    REJECT_REQUEST_ALLOCATE: 'reject_request_allocate',
    // error reason
    // 상점으로부터 차단된 라이더가 해당 상점이 발주한 배달을 배차하려고 할 때
    DENY_ORDER: 'DENY_ORDER',
};
